import { Box, Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { Item } from '../../../common/snippets'
import {
  PDFHeaderColumns,
  PDFHeaderColumnsForBoth,
  PDFHeaderColumnsForBothTwo,
  PDFHeaderColumnsFormattedLRNO,
  PDFHeaderColumnsFormattedLRNOTwo,
  PDFHeaderColumnsTwo,
} from './constant'
import { useSelector } from 'react-redux'
import moment from 'moment'
const LuggageModificationReportTable = ({ fromDate, toDate, tableData, selBranch, lRInput, UseFormattedLRinReports }) => {
  const { loginData } = useSelector((state) => state?.common)
  const companySettings = useSelector((state) => state?.common?.companySettings[0])
  const loginCountryId = companySettings?.DefaultCurrencyID
  const headerDataCol =
    UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1
      ? loginCountryId !== 2
        ? PDFHeaderColumns
        : PDFHeaderColumnsTwo
      : UseFormattedLRinReports === 2
      ? loginCountryId !== 2
        ? PDFHeaderColumnsFormattedLRNO
        : PDFHeaderColumnsFormattedLRNOTwo
      : loginCountryId !== 2
      ? PDFHeaderColumnsForBoth
      : PDFHeaderColumnsForBothTwo
  const InsideRowContent = ({ item, index }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        {item?.isTotal ? (
          <>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={UseFormattedLRinReports === 3 ? 43 : 42}
              style={{ textAlign: 'right', verticalAlign: 'top' }}
            >
              {item.LRNO}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.ItemsOld}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.ItemsNew}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.FreightOld}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.FreightNew}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.DocumentChargesOld}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.DocumentChargesNew}
            </TableCell>
            {loginCountryId !== 2 && (
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
                {item.ServiceTaxAmountOld}
              </TableCell>
            )}
            {loginCountryId !== 2 && (
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
                {item.ServiceTaxAmountNew}
              </TableCell>
            )}
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.InsuranceOld}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.InsuranceNew}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.DeliveryChargesOld}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.DeliveryChargesNew}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.CollectionChargesOld}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.CollectionChargesNew}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.CartageAmountOld}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.CartageAmountNew}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.NetAmountOld}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.NetAmountNew}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}></TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}></TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.CommissionOld}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.CommissionNew}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.DemurrageChgOld}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.DemurrageChgNew}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.HamaliChargesOld}
            </TableCell>
            <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.HamaliChargesNew}
            </TableCell>
          </>
        ) : (
          <>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', minWidth: '140px' }}
            >
              {UseFormattedLRinReports === 2 ? item.FormattedLRNO : item.LRNO}
            </TableCell>
            {UseFormattedLRinReports === 3 && (
              <TableCell
                className="userwiseTD"
                colSpan={1}
                style={{ padding: '8px 9px', verticalAlign: 'top', textAlign: 'left', borderRight: 'none', minWidth: '90px' }}
              >
                {item.FormattedLRNO}
              </TableCell>
            )}
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', verticalAlign: 'top', textAlign: 'left', borderRight: 'none', minWidth: '90px' }}
            >
              {item.EntryDate}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', verticalAlign: 'top', textAlign: 'left', borderRight: 'none', minWidth: '90px' }}
            >
              {item.UserIDModifiedNew}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', minWidth: '10px' }}
            >
              {item.BookingCityOld}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', minWidth: '10px' }}
            >
              {item.BookingCityNew}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', verticalAlign: 'top', textAlign: 'left', minWidth: '140px' }}
            >
              {item.BookingBranchOld}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', verticalAlign: 'top', textAlign: 'left', minWidth: '140px' }}
            >
              {item.BookingBranchNew}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', verticalAlign: 'top', textAlign: 'left', minWidth: '80px' }}
            >
              {item.DestinationCityOld}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', verticalAlign: 'top', textAlign: 'left', minWidth: '80px' }}
            >
              {item.DestinationCityNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: 'top', textAlign: 'left', minWidth: '140px' }}>
              {item.DestinationBranchOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: 'top', textAlign: 'left', minWidth: '140px' }}>
              {item.DestinationBranchNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: 'top', textAlign: 'left', minWidth: '140px' }}>
              {item.Remarks}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: 'top', textAlign: 'left' }}>
              {item.DispatchCityOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.DispatchCityNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top', minWidth: '140px' }}>
              {item.DispatchBranchOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top', minWidth: '140px' }}>
              {item.DispatchBranchNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.DispatchVehicleOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.DispatchVehicleNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.SealNoOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.SealNoNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.DispatchDriverOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.DispatchDriverNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.ModeOfPaymentOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.ModeOfPaymentNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.PaymentTypeOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.PaymentTypeNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.SendingPartyOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.SendingPartyNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.SenderOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.SenderNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.SenderAddressOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.SenderAddressNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.SenderMobileNoOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.SenderMobileNoNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.RecPartyOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.RecPartyNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.RecNameOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.RecNameNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.RecAddressOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.RecAddressNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.RecMobileNoOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'left', verticalAlign: 'top' }}>
              {item.RecMobileNoNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.ItemsOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.ItemsNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.FreightOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.FreightNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.DocumentChargesOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.DocumentChargesNew}
            </TableCell>
            {loginCountryId !== 2 && (
              <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
                {item.ServiceTaxAmountOld}
              </TableCell>
            )}
            {loginCountryId !== 2 && (
              <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
                {item.ServiceTaxAmountNew}
              </TableCell>
            )}
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.InsuranceOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.InsuranceNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.DeliveryChargesOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.DeliveryChargesNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.CollectionChargesOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.CollectionChargesNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.CartageAmountOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.CartageAmountNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.NetAmountOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.NetAmountNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.RemarksOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.RemarksNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.CommissionOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.CommissionNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.DemurrageChgOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.DemurrageChgNew}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.HamaliChargesOld}
            </TableCell>
            <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: 'right', verticalAlign: 'top' }}>
              {item.HamaliChargesNew}
            </TableCell>
          </>
        )}
      </TableRow>
    )
  }
  return (
    <>
      <Stack style={{ margin: '0px 10px', marginRight: '0px' }}>
        <Item className="userReport">
          <Item className="userReport-heading">Report For: Luggage Modification Report</Item>
          <Item className="userReport-buttons">
            <Box>
              <ReactHtmlTableToExcel
                id="ExportToExl"
                className="userWisereporttemExcelBtn"
                table="table-gbDetailsTableReport-xls"
                filename={`Luggage Modification Report`}
                sheet="tablexls"
                buttonText="Export to Excel"
              />
            </Box>
          </Item>
        </Item>
      </Stack>
      <Stack sx={{ marginLeft: 2, marginRight: 1, height: 470 }} className="scroll">
        <TableContainer className="lr-popup-table lrModel " component={Paper} style={{ borderRadius: '6px', border: '1px solid #aeaeae' }}>
          <Table id="table-gbDetailsTableReport-xls" size="small" aria-label="a dense table">
            <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
              <TableRow>
                <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }} colSpan={34}>
                  <h3 style={{ paddingLeft: '17px' }}>Report For: Luggage Modification Report</h3>
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }} colSpan={33}>
                  <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData?.strCompanyName}</h3>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={67}></TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={17}>
                  From Date
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={17}>
                  To Date
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={17}>
                  From Branch
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={16}>
                  LR Search
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={17}>
                  {moment(fromDate).format('DD-MMM-YYYY')}
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={17}>
                  {moment(toDate).format('DD-MMM-YYYY')}
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={17}>
                  {selBranch?.BranchName}
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={16}>
                  {lRInput}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={18}></TableCell>
              </TableRow>
            </TableHead>
            <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: '10px 10px 10px 10px' }}>
              <TableRow className="sammary-heading" style={{ borderRadius: '10px 10px 10px 10px' }}>
                {headerDataCol?.map((item, i) => (
                  <TableCell
                    className="userWiseReportHeading"
                    key={i}
                    style={{ width: item.minWidth, textAlign: item.align, verticalAlign: 'top', whiteSpace: 'pre-line' }}
                  >
                    {item?.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={14}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '14px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData.length > 0 ? (
              <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                {tableData?.map((item, index) => (
                  <InsideRowContent item={item} index={index} key={index} />
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
        </TableContainer>
      </Stack>
    </>
  )
}

export default LuggageModificationReportTable
